<ion-content>
    <ion-toolbar>
        <div class="header">
            <div class="btn-back-menu" (click)="onBackMenu()">
                <button ion-button clear color="light" no-padding>
                    <ion-icon class="no-padding" name="arrow-back"></ion-icon>
                    <strong style="color:black" class="margin-sides">{{ 'GLOBAL_BACK' | translate}}</strong>
                </button>
                <ion-title class="title">Scoreboard</ion-title>
            </div>
        </div> 
    </ion-toolbar>
        <div class="athletes-container">
            <ion-row class="athletes">
                <div class="athlete" *ngFor="let athlete of athletesArray">
                    <span class="athlete-info"><p class="ath-place">{{athlete.place}}</p> <p class="ath-name">{{athlete.name}}</p> <p class="ath-time">{{athlete.time}}</p></span> 
                    <button class="edit-button" (click)="openEditWindow(athlete)"><ion-icon class="edit-icon" name="create-outline"></ion-icon></button>
                </div>
                <hr>
            </ion-row>
        </div>
</ion-content>